import type { Messages } from '../catalogue.en'

/**
 * The Control Center's Connectors section. Composed into the public
 * catalogue by `catalogue.he.ts`; nothing imports this module directly.
 */
export const controlCenterConnectors: Partial<Messages> = {
  "connectors.title": "ערוצי מסירת הודעות",
  'connectors.subtitle':
    'מחברי הדוא"ל, Telegram ו-WhatsApp שדרכם ההתקנה שולחת הודעות: ייעודם, מצבם ומצב פרטי הגישה שלהם. פרטי הגישה נשמרים לכתיבה בלבד ואינם מוצגים לעולם.',
  'connectors.loading': 'טוען מחברים',
  'connectors.loadFailed': 'לא ניתן לטעון מחברים',
  'connectors.forbidden': 'אין לך הרשאה לקרוא מחברים',
  'connectors.unavailable': 'המחברים אינם זמינים כרגע',
  'connectors.tableLabel': 'מלאי המחברים',
  'connectors.empty': 'אין מחברים',
  'connectors.emptyDetail': 'מחברים הרשומים בהתקנה זו יופיעו כאן.',
  'connectors.noMatches': 'אין מחברים שמתאימים למסננים',
  'connectors.noMatchesDetail': 'הרחב או נקה את מסנני העמודות כדי לחזור למלאי המלא.',
  'connectors.column.identity': 'זהות',
  'connectors.column.channel': 'ערוץ',
  'connectors.column.provider': 'ספק',
  'connectors.column.purpose': 'ייעוד',
  'connectors.column.audience': 'קהל',
  'connectors.column.lifecycle': 'מצב',
  'connectors.column.credentials': 'פרטי גישה',
  'connectors.column.migration': 'הגירה',
  'connectors.column.updated': 'שינוי אחרון',
  'connectors.actions': 'פעולות',
  'connectors.editNamed': 'עריכת {name}',
  'connectors.openNamed': 'פתיחת {name}',
  'connectors.unrecognized': '{value} (לא מזוהה)',
  'connectors.identity.unresolved': 'הזהות לא נפתרה',

  'connectors.channel.email': 'דוא"ל',
  'connectors.channel.telegram': 'Telegram',
  'connectors.channel.whatsapp': 'WhatsApp',
  'connectors.provider.smtp': 'SMTP',
  'connectors.provider.telegram_bot_api': 'Telegram Bot API',
  'connectors.provider.twilio_whatsapp': 'Twilio WhatsApp',
  'connectors.purpose.transactional_email': 'דוא"ל תפעולי',
  'connectors.purpose.staff_communications': 'תקשורת עם הצוות',
  'connectors.purpose.patient_communications': 'תקשורת עם מטופלים',
  'connectors.purpose.legacy_mixed': 'ישן: צוות ומטופלים יחד',
  'connectors.purpose.migration_unresolved': 'הגירה לא פתורה',
  'connectors.audience.staff': 'צוות',
  'connectors.audience.patient': 'מטופלים',
  'connectors.audience.none': 'לא הוגדר',
  'connectors.lifecycle.enabled': 'פעיל',
  'connectors.lifecycle.disabled': 'כבוי',
  'connectors.credentials.configured': 'מוגדרים',
  'connectors.credentials.not_configured': 'לא מוגדרים',
  'connectors.credentials.unresolved': 'לא פתורים',
  'connectors.migration.pending': 'ממתין',
  'connectors.migration.key_unavailable': 'המפתח אינו זמין',
  'connectors.migration.invalid_envelope': 'מעטפה לא תקינה',
  'connectors.migration.identity_unresolved': 'הזהות לא פתורה',
  'connectors.migration.ownership_unresolved': 'הבעלות לא פתורה',
  'connectors.migration.legacy_purpose_unresolved': 'הייעוד הישן לא פתור',
  'connectors.migration.resolved': 'נפתר',
  'connectors.migration.cleared': 'נוקה',

  'connectors.detailLoading': 'טוען מחבר',
  'connectors.facts': 'מחבר',
  'connectors.fact.channel': 'ערוץ',
  'connectors.fact.provider': 'ספק',
  'connectors.fact.purpose': 'ייעוד',
  'connectors.fact.audience': 'קהל',
  'connectors.fact.lifecycle': 'מצב',
  'connectors.fact.credentials': 'פרטי גישה',
  'connectors.fact.migration': 'הגירה',
  'connectors.fact.botUsername': 'בוט',
  'connectors.fact.botUserId': 'מזהה הבוט',
  'connectors.fact.smtpHost': 'שרת',
  'connectors.fact.smtpPort': 'פורט',
  'connectors.fact.smtpServerName': 'שם שרת TLS',
  'connectors.fact.smtpTlsMode': 'מצב TLS',
  'connectors.fact.fromAddress': 'כתובת השולח',
  'connectors.fact.fromName': 'שם השולח',
  'connectors.fact.twilioAccountPreview': 'מזהה החשבון',
  'connectors.fact.whatsappFromPreview': 'שולח WhatsApp',
  'connectors.fact.created': 'נוצר',
  'connectors.fact.updated': 'שינוי אחרון',
  'connectors.readOnly': 'לקריאה בלבד',
  'connectors.readOnlyNote': 'ניתן לקרוא את מצב המחבר אך לא לשנותו.',
  'connectors.secretsNote': 'פרטי גישה שמורים אינם מוצגים לעולם. השאירו אותם סגורים כדי לשמור אותם כפי שהם.',
  'connectors.metadata.title': 'ייעוד ומצב',
  'connectors.purpose': 'ייעוד',
  'connectors.lifecycle': 'מצב',
  'connectors.notConfiguredHint': 'יש לשמור פרטי גישה לפני הפעלת המחבר.',
  'connectors.save': 'שמירת המחבר',
  'connectors.saving': 'שומר',
  'connectors.saved': 'המחבר נשמר',
  'connectors.reload': 'טעינה מחדש של המחבר',
  'connectors.reloaded': 'נטען מחדש מהשרת. יש לבדוק את השינויים ולשמור שוב.',
  'connectors.reloadFailed': 'לא ניתן לטעון מחדש את המחבר.',
  'connectors.unsavedIntent': 'טופס מחבר \u2014 נתונים שלא נשמרו',
  'connectors.credentials.title': 'פרטי גישה',
  'connectors.credentials.replace': 'החלפת פרטי הגישה',
  'connectors.credentials.keep': 'שמירת פרטי הגישה הקיימים',
  'connectors.credentials.rotate': 'שמירת פרטי גישה חדשים',
  'connectors.credentials.rotating': 'בודק ושומר',
  'connectors.credentials.rotated': 'פרטי הגישה הוחלפו',
  'connectors.credentials.clear': 'הסרת פרטי הגישה',
  'connectors.credentials.clearing': 'מסיר',
  'connectors.credentials.cleared': 'פרטי הגישה הוסרו',
  'connectors.credentials.clearTitle': 'להסיר את פרטי הגישה השמורים?',
  'connectors.credentials.clearDescription':
    'המחבר יכובה ופרטי הגישה שלו יימחקו. הזהות, הייעוד וההיסטוריה שלו נשמרים, וניתן לשמור פרטי גישה חדשים בהמשך.',
  'connectors.credentials.clearConfirm': 'הסרה',
  'connectors.cancel': 'ביטול',
  'connectors.legacyNote':
    'הבוט הזה הועבר מהגדרת המרפאה הקודמת ועדיין משרת את הצוות ואת המטופלים יחד. יש לבחור ייעוד אחד כדי לפתור אותו; הקהל השני יתפנה אז לבוט אחר.',
  'connectors.unresolvedNote':
    'הרשומה הזו משמרת בוט Telegram שלא ניתן היה להעביר את פרטי הגישה שלו. לא ניתן לשנות כאן את ייעודו או את פרטי הגישה שלו; יש להסיר את פרטי הגישה כדי להוציאו משימוש.',

  'connectors.createTitle': 'מחבר חדש',
  'connectors.create': 'יצירת מחבר',
  'connectors.creating': 'בודק ויוצר',
  'connectors.createNote': 'מחבר חדש מתחיל כבוי. יש להפעילו לאחר שפרטי הגישה שלו נשמרו.',
  'connectors.providerKind': 'ספק',
  'connectors.field.smtpHost': 'שרת SMTP',
  'connectors.field.smtpPort': 'פורט',
  'connectors.field.smtpServerName': 'שם שרת TLS',
  'connectors.field.smtpTlsMode': 'מצב TLS',
  'connectors.field.tls.starttls': 'STARTTLS',
  'connectors.field.tls.tls': 'TLS',
  'connectors.field.fromAddress': 'כתובת השולח',
  'connectors.field.fromName': 'שם השולח',
  'connectors.field.smtpUsername': 'שם משתמש',
  'connectors.field.smtpPassword': 'סיסמה',
  'connectors.field.telegramBotToken': 'אסימון הבוט',
  'connectors.field.twilioAccountSid': 'מזהה החשבון',
  'connectors.field.whatsappFrom': 'שולח WhatsApp',
  'connectors.field.whatsappFromHint': 'בפורמט בין-לאומי, המתחיל בסימן פלוס.',
  'connectors.field.twilioAuthToken': 'אסימון אימות',
  'connectors.problem.smtp': 'יש למלא את השרת, הפורט, שם שרת ה-TLS, כתובת השולח, שם המשתמש והסיסמה.',
  'connectors.problem.smtpPort': 'הפורט חייב להיות מספר שלם בין 1 ל-65535.',
  'connectors.problem.telegram': 'יש להזין את אסימון הבוט.',
  'connectors.problem.twilio': 'יש למלא את מזהה החשבון, שולח ה-WhatsApp ואסימון האימות.',
  'connectors.problem.whatsappFrom': 'שולח ה-WhatsApp חייב להיות מספר בין-לאומי המתחיל בסימן פלוס.',

  'connectors.error.revisionConflict':
    'מישהו אחר שינה את המחבר בזמן שהחלונית הייתה פתוחה. יש לטעון אותו מחדש כדי לראות את הגרסה הנוכחית; הערכים שהזנתם נשמרים.',
  'connectors.error.duplicateIdentity': 'כבר קיים מחבר עם הזהות הזו. יש לפתוח את המחבר הקיים במקום.',
  'connectors.error.purposeConflict':
    'מחבר אחר כבר משרת את הייעוד והקהל האלה. יש לבחור ייעוד אחר, או לשייך מחדש תחילה את המחבר האחר.',
  'connectors.error.identityMismatch':
    'פרטי הגישה האלה שייכים לבוט או לשולח אחר. החלפת פרטי גישה אינה יכולה לשנות את זהות המחבר; יש ליצור מחבר חדש במקום.',
  'connectors.error.notConfigured': 'למחבר אין פרטי גישה, ולכן לא ניתן להפעילו. יש לשמור פרטי גישה תחילה.',
  'connectors.error.migrationUnresolved': 'ההגירה של הרשומה הזו לא פתורה. יש להסיר את פרטי הגישה שלה כדי להוציאה משימוש.',
  'connectors.error.invalid': 'הספק או השרת דחו את השדות האלה. יש לבדוק אותם ולנסות שוב; הערכים שהזנתם נשמרים.',
  'connectors.error.notFound': 'המחבר הזה כבר אינו קיים בשרת.',
  'connectors.error.forbidden': 'אין לך הרשאה לשנות מחברים.',
  'connectors.error.unavailable': 'השרת אינו זמין. הערכים שהזנתם נשמרים.',
  'connectors.error.conflict': 'השרת דחה את השינוי הזה בגלל התנגשות. יש לטעון מחדש את המחבר ולנסות שוב.',
  'connectors.error.unknown': 'השרת החזיר תשובה לא צפויה. הערכים שהזנתם נשמרים.',
}
